'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = PlanCard;

require('./plan-card.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _planFeaturesCard = require('./plan-features-card');

var _planFeaturesCard2 = _interopRequireDefault(_planFeaturesCard);

var _contactUsButton = require('hellosign/components/pricing/contact-us-button');

var _contactUsButton2 = _interopRequireDefault(_contactUsButton);

var _pricingIconPhone2x = require('hellosign/components/pricing/pricing-icon-phone@2x.png');

var _pricingIconPhone2x2 = _interopRequireDefault(_pricingIconPhone2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getPrice(plan, period) {
    if (plan.coupon) {
        if (period === 'Y') {
            return plan.coupon_annual_price;
        } else {
            return plan.coupon_monthly_price;
        }
    } else {
        if (period === 'Y') {
            return plan.annual_price;
        } else {
            return plan.monthly_price;
        }
    }
}

function PlanCard(props) {

    var plan = props.plan;
    var period = props.period || 'M';
    var features = plan.features;

    var periodText = void 0;
    var price = getPrice(plan, period);
    if (period === 'M') {
        periodText = 'per month when paid monthly';
    } else {
        price = price / 12;
        periodText = 'per month when paid annually';
    }
    price = Math.ceil(price);

    var preCouponPrice = void 0;
    if (plan.coupon) {
        var oldPrice = props.period === 'Y' ? Math.ceil(plan.annual_price / 12) : plan.monthly_price;

        preCouponPrice = _react2['default'].createElement(
            'div',
            { className: 'm-pricing-level' },
            _react2['default'].createElement(
                'div',
                { className: 'm-pricing-level--body small-4 large-12 small-centered columns level-price' },
                _react2['default'].createElement(
                    'div',
                    { className: 'dollar crossed' },
                    '$'
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'price crossed' },
                    oldPrice
                )
            )
        );
    }

    var details = void 0;
    if (plan.is_enterprise) {
        details = _react2['default'].createElement(
            'div',
            { className: 'plan-details' },
            _react2['default'].createElement(
                'div',
                { className: 'plan-name' },
                plan.name
            ),
            _react2['default'].createElement(
                'div',
                { className: 'enterprise-plan-text' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Looking for more?'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Our Sales team can help find the perfect plan for you.'
                )
            ),
            _react2['default'].createElement(_contactUsButton2['default'], {
                timePeriod: period,
                pricingSource: props.pricingSource,
                modalHeaderText: 'Contact Us for an Enterprise Plan',
                onSuccess: props.onEnterpriseSuccess,
                buttonText: 'Contact Us' })
        );
    } else {
        var planChoiceParameters = {
            planId: plan.plan_id,
            timePeriod: period,
            price: getPrice(plan, period)
        };
        details = _react2['default'].createElement(
            'div',
            { className: 'plan-details' },
            _react2['default'].createElement(
                'div',
                { className: 'plan-name' },
                plan.name
            ),
            preCouponPrice,
            _react2['default'].createElement(
                'div',
                { className: 'price' },
                _react2['default'].createElement(
                    'span',
                    { className: 'currency' },
                    '$'
                ),
                _react2['default'].createElement(
                    'span',
                    { className: 'amount' },
                    price
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'period' },
                periodText
            ),
            _react2['default'].createElement(_button2['default'], {
                buttonText: 'START 30-DAY FREE TRIAL',
                onClick: function onClick() {
                    return props.onPlanChoice(planChoiceParameters);
                } })
        );
    }

    return _react2['default'].createElement(
        'div',
        { className: 'm-plan-card' },
        details,
        _react2['default'].createElement(_planFeaturesCard2['default'], { features: features })
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/v2/plan-card.jsx
 ** module id = 1168
 ** module chunks = 0
 **/